import React from 'react';
import { Box, Container, SimpleGrid } from '@chakra-ui/react';
import { CircleDollarSign, LineChart, Search, UserRound } from 'lucide-react';
import ProcessStep from '../ui/ProcessStep';
import SectionHeading from '../ui/SectionHeading';

const STEPS = [
  {
    number: 1,
    icon: UserRound,
    title: 'Create Account',
    description: 'Sign up and complete verification in minutes.',
  },
  {
    number: 2,
    icon: Search,
    title: 'Browse Properties',
    description: 'Explore curated investment opportunities.',
  },
  {
    number: 3,
    icon: CircleDollarSign,
    title: 'Invest Securely',
    description: 'Invest from as little as $1,000 through our secure platform.',
  },
  {
    number: 4,
    icon: LineChart,
    title: 'Track Performance',
    description: 'Monitor your investment and earn passive income.',
  },
];

const HowItWorksSection = () => {
  return (
    <Box as="section" py={{ base: 6, md: 6 }} bg="#071326">
      <Container maxW="container.xl" px={{ base: 5, md: 8 }}>
        <SectionHeading
          align="center"
          size="lg"
          title="How It Works"
          mb={{ base: 7, md: 7 }}
        />

        <SimpleGrid
          columns={{ base: 2, md: 4 }}
          spacing={{ base: 6, md: 4 }}
        >
          {STEPS.map((step, index) => (
            <ProcessStep
              key={step.number}
              number={step.number}
              icon={step.icon}
              title={step.title}
              description={step.description}
              isLast={index === STEPS.length - 1}
            />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default HowItWorksSection;
